"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_input_1 = require("../input/awsui-input");
var BaseCollectionFilteringWrapper = /** @class */ (function (_super) {
    __extends(BaseCollectionFilteringWrapper, _super);
    function BaseCollectionFilteringWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseCollectionFilteringWrapper.prototype.findInput = function () {
        return new awsui_input_1.default(this.find('awsui-input').getElement());
    };
    BaseCollectionFilteringWrapper.prototype.findResultsCount = function () {
        return this.find('.awsui-filtering-results');
    };
    return BaseCollectionFilteringWrapper;
}(dom_1.ComponentWrapper));
exports.BaseCollectionFilteringWrapper = BaseCollectionFilteringWrapper;
var TableFilteringWrapper = /** @class */ (function (_super) {
    __extends(TableFilteringWrapper, _super);
    function TableFilteringWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableFilteringWrapper;
}(BaseCollectionFilteringWrapper));
exports.default = TableFilteringWrapper;
//# sourceMappingURL=awsui-table-filtering.js.map